<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title" style="margin-top:0px">Clients</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-2 offset-lg-5 text-center">
            <span :class="{ text_underline: !mapActive}">Liste</span>&nbsp;&nbsp;
            <el-switch
              v-model="mapActive"
              active-color="#13ce66"
              inactive-color="#13ce66"
              @change="changeComponent()">
            </el-switch>&nbsp;&nbsp;
            <span :class="{ text_underline: mapActive}">Carte</span>
          </div>
          <div class="col-lg-2 offset-lg-3 text-right">
            <el-button-group>
              <el-button @click="$router.push('clientCreate')" type="success" class="btn-action"><i class="fa fa-plus-circle"></i></el-button>
            </el-button-group>
          </div>
        </div>
        <component class="mt-5" v-bind:is="CurrentComponentContent"></component>
      </div>
    </div>
  </div>
</template>
<script>
	import Vue from 'vue'
	import adminTable from './table.vue'
	import adminMap from './map.vue'
  import VueJwtDecode from 'vue-jwt-decode'
  import {Switch, ButtonGroup} from 'element-ui'
  Vue.use(Switch)
  Vue.use(ButtonGroup)
  export default{
    components: {
      
    },
    computed: {
      
    },
    data () {
      return {
        CurrentComponentContent:'',
        mapActive:false
      }
    },
    methods: {
      changeComponent(component) {
        if(this.mapActive == false) {
          this.CurrentComponentContent = adminTable
          this.mapActive=false
        } else {
          this.CurrentComponentContent = adminMap
          this.mapActive=true
        }
      }
    },
    created() {
        this.CurrentComponentContent = adminTable
    },
  }
</script>
